<template>
    <div class="myInput" @keyup.enter="handleSearch">
        <input type="text" :value="value" @input="$emit('input', $event.target.value)" :placeholder="paramData&&paramData.placeholder?paramData.placeholder:'输入规则名称'" />
        <i class="el-icon-search" @click="handleSearch"></i>
    </div>
</template>
<script>
export default {
    data() {
        return {
            token: ''
        };
    },
    props: [
        "searchApi", "paramData", 'value'
    ],
    created() {
        this.token = this.$cookies.get("token");
    },
    methods: {
        handleSearch() {
            let that = this;
            let params = {
                token: this.token,
                search: this.value,
            };
            if (this.paramData) {
                this.paramData.typeid && (params.typeid = this.paramData.typeid)
                this.paramData.from && (params.from = this.paramData.from)
                this.paramData.date && this.paramData.date.length>0 && (params.time_s = this.paramData.date[0])
                this.paramData.date && this.paramData.date.length>0 && (params.time_e = this.paramData.date[1])
                this.paramData.typeid && (params.typeid = this.paramData.typeid)
                this.paramData.shenhe && (params.shenhe = this.paramData.shenhe)
                this.paramData.user_id && (params.user_id = this.paramData.user_id)
            }
            $.ajax({
                url: process.env.apiUrl + 'point/' + that.searchApi,
                type: "post",
                data: params,
                success: function(data, status) {
                    if (data.status == 1) {
                        if (data.data.length == 0) {
                            that.$message({
                                type: "warning",
                                message: "无此搜索数据!"
                            });      
                        } else {
                            that.$emit('searchData', data)
                        }
                    } else  {
                        that.$message.error(data.msg);
                    }
                },
                fail: function(err, status) {
                    console.log(err);
                }
            });
        },       
    }
};
</script>
<style scoped>
.myInput {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    width: 230px;
    height: 40px;
    background: #fff;
}
.myInput i {
    display: inline-block;
    vertical-align: middle;
    width: 40px;
    height: 100%;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.myInput input {
    width: calc(100% - 60px);
    height: 100%;
    padding-left: 10px;
    font-size: 14px;
    outline: none;
    border: none;
    background: none;
}
/*修改提示文字的颜色*/
input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #C3C4D5;
}

input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #C3C4D5;
}

input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #C3C4D5;
}

input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #C3C4D5;
}
</style>



// WEBPACK FOOTER //
// src/components/mySearch.vue